import React from 'react';

import { Button } from 'antd';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

/**
 * Madde Gönder Butonu
 *
 * @param {Object} props
 * @param {number|string} props.offerId Butonun yönlendireceği maddenin id'si.
 * @param {boolean} [props.disabled] Buton pasif mi.
 * @param {string} [props.path='yeni-icerik-ekle'] Yönlendirilecek gönderim ekranının route segmenti.
 * @param {string} [props.label] Buton metni; verilmezse `article.status.sendItem` çevirisi kullanılır.
 *   Aynı buton farklı rollerin gönderim girişleri için kullanıldığından metin dışarıdan verilebilir.
 */
const SendItemSteps = ({ offerId, disabled, path = 'yeni-icerik-ekle', label }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="modalBtnGrp">
      <Button
        block
        disabled={disabled}
        className="modalBtnStyle"
      >
        <Link to={`/${path}/${offerId}`}>{label ?? formatMessage({ id: 'article.status.sendItem' })}</Link>
      </Button>
    </div>
  );
};

export default SendItemSteps;
